import type { ReactNode } from "react";
import { Stack, Typography } from "@mui/material";

export interface EmptyStateProps {
  /** Decorative glyph. Caller must pass `aria-hidden="true"` on the icon node. */
  icon?: ReactNode;
  title: string;
  description: string;
  action?: ReactNode;
}

/**
 * Static empty-state placeholder. The wrapper carries `role="status"`, an
 * implicit polite live region, so screen readers announce it when content
 * transitions from a loading state. Do not nest inside another live region.
 */
export default function EmptyState({
  icon,
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <Stack
      role="status"
      spacing={1.5}
      alignItems="center"
      sx={{ py: 6, px: 2, textAlign: "center" }}
    >
      {icon}
      <Typography variant="subtitle1" component="p">
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
      {action}
    </Stack>
  );
}
